export const surfacesNb = {
  'moderation.reviewSaved': 'Gjennomgangsdetaljene er lagret.',
  'moderation.reviewSaveFailed': 'Kunne ikke lagre gjennomgangen.',
  'moderation.reasonRequired': 'Legg til en begrunnelse før du utfører en handling.',
  'moderation.confirmTitle': '{action} dette innholdet?',
  'moderation.confirmBody': 'Dette oppretter en permanent revisjonsoppføring. Kontroller innholdet og begrunnelsen før du fortsetter.',
  'moderation.confirmAction': 'Bekreft handling',
  'moderation.actionRecorded': 'Modereringshandlingen er registrert.',
  'moderation.actionFailed': 'Kunne ikke utføre handlingen.',
  'moderation.appealPrompt': 'Forklar denne klageavgjørelsen til klageren:',
  'moderation.appealRecorded': 'Klageavgjørelsen er registrert.',
  'moderation.appealFailed': 'Kunne ikke avgjøre klagen.',
  'moderation.staffOnly': 'Kun for ansatte',
  'moderation.title': 'Innholdsmoderering',
  'moderation.intro': 'Behandle rapporter konsekvent. Rapportøridentitet og interne notater er bare synlige for autoriserte moderatorer.',
  'moderation.queue': 'Rapportkø',
  'moderation.status': 'Status',
  'moderation.open': 'Åpne',
  'moderation.resolved': 'Løst',
  'moderation.dismissed': 'Avvist',
  'moderation.all': 'Alle',
  'moderation.target': 'Mål',
  'moderation.loadingReports': 'Laster rapporter',
  'moderation.noReports': 'Ingen rapporter samsvarer med filtrene.',
  'moderation.created': 'Opprettet',
  'moderation.reason': 'Årsak',
  'moderation.priority': 'Prioritet',
  'moderation.review': 'Gjennomgå',
  'moderation.noDetails': 'Rapportøren oppga ingen detaljer.',
  'moderation.reviewTarget': 'Gjennomgå rapport om {target}',
  'moderation.closeReview': 'Lukk gjennomgang',
  'moderation.evidence': 'Øyeblikksbilde av bevis',
  'moderation.assignTo': 'Tildel til',
  'moderation.unassigned': 'Ikke tildelt',
  'moderation.internalNotes': 'Interne notater',
  'moderation.saveAssignment': 'Lagre tildeling og notater',
  'moderation.action': 'Modereringshandling',
  'moderation.reasonCode': 'Årsakskode',
  'moderation.requiredRationale': 'Påkrevd beslutningsgrunnlag',
  'moderation.reviewConfirm': 'Gjennomgå og bekreft handlingen',
  'moderation.pendingAppeals': 'Ventende klager',
  'moderation.noAppeals': 'Ingen ventende klager.',
  'moderation.overturn': 'Omgjør',
  'moderation.uphold': 'Oppretthold',
  'venue.application.proofError': 'Kunne ikke behandle bildet. Prøv en JPEG-, PNG-, HEIC- eller PDF-fil.',
  'venue.application.submitted': 'Søknaden er sendt til vurdering.',
  'venue.application.submitError': 'Kunne ikke sende søknaden. Prøv igjen.',
  'venue.application.eyebrow': 'Virksomhetsverifisering',
  'venue.application.title': 'Bli en verifisert virksomhet',
  'venue.application.intro': 'Verifiserte profesjonelle verter får et tillitsmerke, synlighet i søk, teamtilgang og verktøy for gjentakende arrangementer.',
  'venue.application.status.pending': 'Venter',
  'venue.application.status.approved': 'Godkjent',
  'venue.application.status.rejected': 'Avslått',
  'venue.application.pendingHelp': 'Vi gjennomgår virksomhetsopplysningene og dokumentasjonen.',
  'venue.application.name': 'Navn på virksomhet eller organisasjon',
  'venue.application.location': 'Fast sted (valgfritt når det ikke er relevant)',
  'venue.application.website': 'Nettsted eller meny',
  'venue.application.phone': 'Offentlig telefonnummer',
  'venue.application.proof': 'Dokumentasjon på adresse eller eierskap',
  'venue.application.converting': 'Konverterer bilde …',
  'venue.application.proofHelp': 'JPEG, PNG, HEIC eller PDF. Bare synlig for de som vurderer søknaden.',
  'venue.application.submitting': 'Sender …',
  'venue.application.submit': 'Send søknad',
  'venue.dashboard.nav.workspace': 'Arbeidsområde',
  'venue.dashboard.nav.overview': 'Oversikt',
  'venue.dashboard.nav.overviewHelp': 'Virksomhetsaktivitet på et øyeblikk',
  'venue.dashboard.backToSettings': 'Tilbake til virksomhetsinnstillinger',
  'venue.dashboard.nav.operations': 'Drift',
  'venue.dashboard.nav.operationsHelp': 'Bestillinger og driftsoppgaver',
  'venue.dashboard.nav.events': 'Arrangementer',
  'venue.dashboard.nav.eventsHelp': 'Det offentlige programmet ditt',
  'venue.dashboard.nav.resources': 'Ressurser',
  'venue.dashboard.nav.resourcesHelp': 'Bestillbar katalog og side',
  'venue.dashboard.nav.community': 'Fellesskap',
  'venue.dashboard.nav.communityHelp': 'Innlegg, katalog og chat',
  'venue.dashboard.nav.inbox': 'Innboks',
  'venue.dashboard.nav.inboxHelp': 'Delte kundemeldinger',
  'venue.dashboard.nav.business': 'Virksomhet',
  'venue.dashboard.nav.profile': 'Profil',
  'venue.dashboard.nav.profileHelp': 'Offentlige virksomhetsdetaljer',
  'venue.dashboard.nav.team': 'Team',
  'venue.dashboard.nav.teamHelp': 'Tilgang og revisjonsspor',
  'venue.dashboard.nav.notifications': 'Varsler',
  'venue.dashboard.nav.notificationsHelp': 'Standardvalg for arrangør og levering',
  'venue.dashboard.nav.performance': 'Resultater',
  'venue.dashboard.nav.insights': 'Innsikt',
  'venue.dashboard.nav.insightsHelp': 'Samlede arrangementsresultater',
  'venue.dashboard.nav.finance': 'Økonomi',
  'venue.dashboard.nav.financeHelp': 'Betalinger og abonnement',
  'venue.dashboard.nav.preferences': 'Innstillinger',
  'venue.dashboard.nav.preferencesHelp': 'Virksomhetsspråk',
  'venue.dashboard.nav.account': 'Tilgang og sikkerhet',
  'venue.dashboard.nav.accountHelp': 'Innlogging og økttilgang',
  'venue.dashboard.nav.data': 'Virksomhetsdata',
  'venue.dashboard.nav.dataHelp': 'Eksport og avvikling',
  'venue.dashboard.system': 'System',
  'venue.dashboard.profileSaved': 'Virksomhetsprofilen er lagret.',
  'venue.dashboard.profileSaveFailed': 'Kunne ikke lagre stedsprofilen.',
  'venue.dashboard.notificationsSaved': 'Varslingsinnstillingene er lagret.',
  'venue.dashboard.notificationsSaveFailed': 'Kunne ikke lagre varslingsinnstillingene.',
  'venue.dashboard.languageSaveFailed': 'Kunne ikke lagre virksomhetsspråket.',
  'venue.dashboard.emailRequested': 'Sjekk den nye e-postadressen for å bekrefte endringen.',
  'venue.dashboard.emailRequestFailed': 'Kunne ikke be om endring av e-post.',
  'venue.dashboard.passwordInvalid': 'Passordene må samsvare og inneholde minst 8 tegn.',
  'venue.dashboard.passwordChanged': 'Passordet er endret.',
  'venue.dashboard.passwordChangeFailed': 'Kunne ikke endre passordet.',
  'venue.dashboard.exportDownloaded': 'Eksporten av virksomhetsdata er lastet ned.',
  'venue.dashboard.exportFailed': 'Kunne ikke eksportere virksomhetsdata.',
  'venue.dashboard.closureConfirmTitle': 'Planlegg avvikling av virksomheten?',
  'venue.dashboard.closureConfirmBody': 'Virksomhetskontoen og eid innhold slettes permanent etter angrefristen på 7 dager. Ansattkontoer slettes ikke.',
  'venue.dashboard.scheduleClosure': 'Planlegg avvikling',
  'venue.dashboard.keepBusiness': 'Behold virksomheten',
  'venue.dashboard.closureScheduled': 'Avvikling av virksomheten er planlagt.',
  'venue.dashboard.closureFailed': 'Kunne ikke planlegge avvikling.',
  'venue.dashboard.invitationCreated': 'Teaminvitasjonen er opprettet.',
  'venue.dashboard.invitationFailed': 'Kunne ikke invitere brukeren.',
  'venue.dashboard.invitationAccepted': 'Invitasjonen til stedet er godtatt.',
  'venue.dashboard.invitationDeclined': 'Invitasjonen til stedet er avslått.',
  'venue.dashboard.invitationUpdateFailed': 'Kunne ikke oppdatere invitasjonen.',
  'venue.dashboard.transferTitle': 'Overfør eierskapet til stedet?',
  'venue.dashboard.transferBody': 'Den nye eieren får full kontroll over stedet og teamet.',
  'venue.dashboard.transfer': 'Overfør eierskap',
  'venue.dashboard.transferSuccess': 'Eierskapet er overført.',
  'venue.dashboard.roleUpdated': 'Teamrollen er oppdatert.',
  'venue.dashboard.roleUpdateFailed': 'Kunne ikke oppdatere rollen.',
  'venue.dashboard.removeTitle': 'Fjern teammedlem?',
  'venue.dashboard.removeBody': 'Personen mister umiddelbart tilgang til stedsoversikten.',
  'venue.dashboard.remove': 'Fjern',
  'venue.dashboard.memberRemoved': 'Teammedlemmet er fjernet.',
  'venue.dashboard.memberRemoveFailed': 'Kunne ikke fjerne teammedlemmet.',
  'venue.dashboard.event': 'Arrangement',
  'venue.dashboard.date': 'Dato',
  'venue.dashboard.waitlisted': 'På venteliste',
  'venue.dashboard.noShows': 'Ikke møtt',
  'venue.dashboard.repeatParticipants': 'Gjentatte deltakere',
  'venue.dashboard.feedback': 'Tilbakemelding',
  'venue.dashboard.title': 'Virksomhetsoversikt',
  'venue.dashboard.sectionIntro': '{section} for offentlig profil, program og team.',
  'venue.dashboard.invitedAs': 'Du er invitert til å bli med i en virksomhet som {role}.',
  'venue.dashboard.accept': 'Godta',
  'venue.dashboard.decline': 'Avslå',
  'venue.dashboard.restricted': 'Denne oversikten er tilgjengelig for verifiserte virksomheter og godkjente ansatte.',
  'venue.dashboard.businessApplication': 'Virksomhetssøknad',
  'venue.dashboard.shortcutsAria': 'Snarveier i virksomhetsoversikten',
  'venue.dashboard.sectionsAria': 'Deler av virksomhetsoversikten',
  'venue.dashboard.upcomingEvents': 'Kommende arrangementer',
  'venue.dashboard.publicProgramme': 'Offentlig program fremover',
  'venue.dashboard.teamMembers': 'Teammedlemmer',
  'venue.dashboard.acceptedStaff': 'Godkjente ansatte',
  'venue.dashboard.measuredEvents': 'På tvers av målte arrangementer',
  'venue.dashboard.publicProfile': 'Offentlig profil',
  'venue.dashboard.business': 'Virksomhet',
  'venue.dashboard.addAddress': 'Legg til en adresse',
  'venue.dashboard.quickActions': 'Hurtighandlinger',
  'venue.dashboard.createEvent': 'Opprett arrangement',
  'venue.dashboard.openOperations': 'Åpne drift',
  'venue.dashboard.manageResources': 'Administrer ressurser',
  'venue.dashboard.editProfile': 'Rediger profil',
  'venue.dashboard.eventsHelp': 'Opprett enkeltarrangementer eller bruk gjentakelse for faste programmer.',
  'venue.dashboard.eventsLoadFailed': 'Kunne ikke laste virksomhetens arrangementer. Prøv igjen.',
  'venue.dashboard.noEvents': 'Ingen virksomhetsarrangementer ennå.',
  'venue.dashboard.starts': 'Starter',
  'venue.dashboard.responses': 'Svar',
  'venue.dashboard.going': 'Ingen deltar | {count} deltar | {count} deltar',
  'venue.dashboard.open': 'Åpne',
  'venue.dashboard.profileHelp': 'Verifisering styres av administratorer. Virksomhetsansatte kan oppdatere de offentlige detaljene nedenfor.',
  'venue.dashboard.newProfileImage': 'Nytt profilbilde for virksomheten',
  'venue.dashboard.currentProfileImage': 'Gjeldende profilbilde for {name}',
  'venue.dashboard.logo': 'Logo eller profilbilde',
  'venue.dashboard.businessName': 'Virksomhetsnavn',
  'venue.dashboard.publicHandle': 'Offentlig brukernavn',
  'venue.dashboard.businessIntro': 'Presentasjon av virksomheten',
  'venue.dashboard.publicAddress': 'Offentlig adresse',
  'venue.dashboard.website': 'Nettsted',
  'venue.dashboard.phone': 'Telefon',
  'venue.dashboard.accessibility': 'Tilgjengelighetsinformasjon',
  'venue.dashboard.accessibilityPlaceholder': 'Trinnfri tilgang, tilgjengelige toaletter, teleslynge …',
  'venue.dashboard.mapLocation': 'Kartposisjon',
  'venue.dashboard.mapLocationHelp': 'En kartposisjon er allerede angitt. Søk nedenfor bare hvis du vil erstatte den.',
  'venue.dashboard.addPhotos': 'Legg til virksomhetsbilder',
  'venue.dashboard.photoAlt': 'Virksomhetsbilde {number}',
  'venue.dashboard.photoAltLabel': 'Alternativ tekst for bilde {number}',
  'venue.dashboard.describePhoto': 'Beskriv bildet',
  'venue.dashboard.saving': 'Lagrer …',
  'venue.dashboard.saveProfile': 'Lagre offentlig profil',
  'venue.dashboard.editorProfileRestriction': 'Redaktører kan administrere programmet, men ikke endre den offentlige profilen.',
  'venue.dashboard.insightsTitle': 'Personvernvennlig innsikt',
  'venue.dashboard.exportCsv': 'Eksporter samlet CSV',
  'venue.dashboard.insightsPrivacy':
    'Anonyme visninger dedupliseres daglig. Tilbakemelding skjules ved færre enn fem svar. Individuell nettleserhistorikk lagres eller vises aldri.',
  'venue.dashboard.noInsights': 'Innsikt vises når arrangementene mottar svar.',
  'venue.dashboard.discovery': 'Utforsking',
  'venue.dashboard.waitlist': 'Venteliste',
  'venue.dashboard.repeat': 'Gjentatte',
  'venue.dashboard.noShowCount': 'Ingen uteblitte | {count} uteblitt | {count} uteblitte',
  'venue.dashboard.suppressed': 'Skjult',
  'venue.dashboard.businessTeam': 'Virksomhetsteam',
  'venue.dashboard.teamHelp': 'Eiere har full kontroll, ledere administrerer profil og team, og redaktører administrerer bare programmet.',
  'venue.dashboard.userId': 'Brukerkonto-ID',
  'venue.dashboard.userIdPlaceholder': 'PocketBase-bruker-ID',
  'venue.dashboard.role': 'Rolle',
  'venue.dashboard.editor': 'Redaktør',
  'venue.dashboard.manager': 'Leder',
  'venue.dashboard.invite': 'Inviter',
  'venue.dashboard.you': 'deg',
  'venue.dashboard.owner': 'Eier',
  'venue.dashboard.removeMemberAria': 'Fjern teammedlem',
  'venue.dashboard.auditTrail': 'Revisjonsspor',
  'venue.dashboard.auditHelp': 'Sensitive endringer i profil, team og eierskap beholdes for ansvarlighet.',
  'venue.dashboard.noAudit': 'Ingen revisjonsoppføringer ennå.',
  'venue.dashboard.businessNotifications': 'Virksomhetsvarsler',
  'venue.dashboard.notificationsHelp':
    'Konfigurer meldinger som sendes til virksomhetsidentiteten. Ansatte styrer levering til egne kontoer i personlige innstillinger.',
  'venue.dashboard.organizedEvents': 'Arrangementer du organiserer',
  'venue.dashboard.remindAttendees': 'Minn deltakere på arrangementer',
  'venue.dashboard.reminderLead': 'Standard tid før påminnelse (timer)',
  'venue.dashboard.webPush': 'Web-push',
  'venue.dashboard.email': 'E-post',
  'venue.dashboard.importantChanges': 'Viktige arrangementsendringer',
  'venue.dashboard.upcomingReminders': 'Påminnelser om kommende arrangementer',
  'venue.dashboard.discussionMentions': 'Arrangementssamtaler og omtaler',
  'venue.dashboard.saveNotifications': 'Lagre varsler',
  'venue.dashboard.businessLanguage': 'Virksomhetsspråk',
  'venue.dashboard.languageHelp': 'Brukes for virksomhetskontoen og kommunikasjon fra virksomheten der oversettelse er tilgjengelig.',
  'venue.dashboard.saveLanguage': 'Lagre språk',
  'venue.dashboard.loginEmail': 'E-post for innlogging',
  'venue.dashboard.requestEmailChange': 'Be om endring av e-post',
  'venue.dashboard.changePassword': 'Endre passord',
  'venue.dashboard.currentPassword': 'Nåværende passord',
  'venue.dashboard.newPassword': 'Nytt passord',
  'venue.dashboard.confirmPassword': 'Bekreft nytt passord',
  'venue.dashboard.session': 'Økt',
  'venue.dashboard.sessionHelp': 'Logg ut når virksomhetskontoen er åpen på en delt enhet.',
  'venue.dashboard.signOut': 'Logg ut',
  'venue.dashboard.dataClosure': 'Virksomhetsdata og avvikling',
  'venue.dashboard.dataClosureHelp': 'Eksporter virksomhetsdata eller planlegg avvikling. Ansatte beholder sine uavhengige personlige kontoer.',
  'venue.dashboard.portableExport': 'Flyttbar eksport',
  'venue.dashboard.portableExportHelp':
    'Inneholder virksomhetsprofil, innstillinger, innhold virksomheten er vert for, og eventuelle bevarte eldre personoppføringer.',
  'venue.dashboard.exporting': 'Eksporterer …',
  'venue.dashboard.downloadExport': 'Last ned eksport',
  'venue.dashboard.closeBusiness': 'Avvikle virksomhetskonto',
  'venue.dashboard.closeBusinessHelp': 'Avvikling har en angrefrist på 7 dager og sletter ikke de ansattes personlige kontoer.',
  'organizer.setup.pageTitle': 'Arrangøroppsett',
  'organizer.setup.hostTitle': 'Velg hvordan du vil være vert',
  'organizer.setup.hostDescription': 'Bruk profilen din for uformelle arrangementer, eller opprett en gruppe for et fast fellesskap.',
  'organizer.setup.createGroup': 'Opprett en gruppe',
  'organizer.setup.publishTitle': 'Publiser ditt første arrangement',
  'organizer.setup.publishDescription': 'Legg inn det viktigste og publiser når dato, tilgang, kapasitet, pris og sted er klart.',
  'organizer.setup.createEvent': 'Opprett arrangement',
  'organizer.setup.inviteTitle': 'Inviter deltakere',
  'organizer.setup.inviteDescription': 'Åpne Administrer-fanen for arrangementet og velg hvem du vil invitere.',
  'organizer.setup.openEvent': 'Åpne arrangement',
  'organizer.setup.createEventFirst': 'Opprett arrangement først',
  'organizer.setup.responseTitle': 'Motta det første svaret',
  'organizer.setup.responseCount': 'Ingen deltakere har svart ennå. | {count} deltaker har svart så langt. | {count} deltakere har svart så langt.',
  'organizer.setup.responseDescription': 'Svar vises her etter at en invitert person godtar, avslår, ber om tilgang eller stiller seg på venteliste.',
  'organizer.setup.viewEvent': 'Vis arrangement',
  'organizer.setup.badge': 'Arrangøroppsett',
  'organizer.setup.title': 'Få ditt første arrangement i gang',
  'organizer.setup.intro': 'Denne sjekklisten fortsetter fra faktisk aktivitet på kontoen. Den blokkerer aldri deltakerfunksjoner.',
  'organizer.setup.progressAria': 'Fremdrift for arrangøroppsett',
  'organizer.setup.progress': '{count} av 4 trinn fullført',
  'organizer.setup.loading': 'Laster arrangørfremdrift',
  'organizer.setup.hostMyself': 'Vær vert som meg selv',
  'organizer.setup.complete': 'Arrangøroppsettet er fullført. Hold fremdriften oppe ved å planlegge neste arrangement.',
  'organizer.setup.createAnother': 'Opprett et nytt',
  'privacy.eyebrow': 'Vennevents personvernerklæring',
  'privacy.title': 'Arrangementsdataene dine tilhører deg. Publiser dem hvor som helst.',
  'privacy.intro': 'Vennevent hjelper mennesker å møtes i virkeligheten uten å gjøre relasjoner, interesser eller oppholdssted om til en reklameprofil.',
  'privacy.effective': 'Gjelder fra 25. juli 2026 · Retningslinjer før lansering',
  'privacy.plain.heading': 'Kort fortalt',
  'privacy.plain.p1':
    'Vi samler inn opplysningene som trengs for å drive arrangementer, grupper, kontoer, betalinger, sikkerhetsfunksjoner og varsler. Vi selger ikke personopplysninger, bruker ikke tredjeparts sporing for reklame og lager ikke profiler for målrettet annonsering. Samtaler og medier knyttet til arrangementer lagres med vilje bare en kort tid.',
  'privacy.plain.p2':
    'Du styrer hva du publiserer, kan endre profilsynlighet og varslingsvalg, laste ned en flyttbar kopi av dataene dine og planlegge sletting av kontoen i Innstillinger.',
  'privacy.controller.heading': 'Hvem er ansvarlig',
  'privacy.controller.beforeLink':
    'Vennevent er foreløpig en tjeneste før lansering. Behandlingsansvarliges juridiske navn, postadresse og direkte personvernkontakt må publiseres her før offentlig registrering åpner. Frem til da kan personvernforespørsler utføres med selvbetjeningskontrollene i',
  'privacy.data.heading': 'Opplysninger vi behandler',
  'privacy.data.accountTitle': 'Konto og profil:',
  'privacy.data.account':
    'e-post, valgfritt verifisert telefonnummer, autentiseringsopplysninger, visningsnavn, brukernavn, profilbilde, biografi, språk og personvernvalg.',
  'privacy.data.eventsTitle': 'Arrangementer og grupper:',
  'privacy.data.events':
    'opplysninger du publiserer, steder, tidsplaner, bilder, innlegg, kommentarer, chat, medlemskap, invitasjoner, svar, ventelister, billetter og innsjekkinger.',
  'privacy.data.privateTitle': 'Private valg:',
  'privacy.data.private':
    'bokmerker, lagrede strømmer og personer, følging, varslingsinnstillinger, interesser fra introduksjonen, omtrentlig område for utforsking, private minner og aldersopplysninger når et arrangement har aldersgrense.',
  'privacy.data.businessTitle': 'Virksomhets- og betalingsopplysninger:',
  'privacy.data.business':
    'virksomhetssøknader, ansattilganger, bestillingsdetaljer, betalingsstatus, refusjoner og nødvendige transaksjonsidentifikatorer. Betalingsleverandører behandler betalingsopplysninger etter egne vilkår.',
  'privacy.data.technicalTitle': 'Tekniske opplysninger og sikkerhet:',
  'privacy.data.technical':
    'innloggingsøkter, push-abonnementer, sikkerhets- og modereringsoppføringer, driftslogger, omtrentlig sted fra IP, nettleser-/enhetsopplysninger, feilrapporter og ytelsesspor.',
  'privacy.data.guests':
    'Svar som gjest krever ikke konto eller e-post. Gjestens visningsnavn og svarstatus beholdes bare så lenge arrangementet trenger dem. Fødselsdato oppgitt av en gjest for alderskontroll sjekkes midlertidig og lagres ikke.',
  'privacy.data.contacts':
    'Hvis du velger kontaktimport, deler nettleseren bare kontaktene og feltene du velger. Vennevent sjekker e-postadressene og telefonnumrene mot søkbare kontoer, returnerer offentlig profilinformasjon ved treff og forkaster kontaktopplysninger uten treff uten å lagre dem.',
  'privacy.purpose.heading': 'Hvorfor vi bruker opplysningene',
  'privacy.purpose.purpose': 'Formål',
  'privacy.purpose.basis': 'Vanlig rettslig grunnlag',
  'privacy.purpose.service': 'Levere kontoer, utforsking, arrangementer, grupper, svar, invitasjoner, billetter og varsler du ber om',
  'privacy.purpose.contract': 'Oppfylle avtalen med deg',
  'privacy.purpose.payments': 'Behandle betalte bestillinger og oppbevare nødvendige transaksjonsoppføringer',
  'privacy.purpose.contractLegal': 'Avtale og rettslige plikter',
  'privacy.purpose.safety': 'Hindre misbruk, sikre tjenesten, moderere rapporter og opprettholde stabil drift',
  'privacy.purpose.legitimate': 'Berettigede interesser og, der det gjelder, rettslige plikter',
  'privacy.purpose.optional': 'Bruke valgfri nettleserposisjon, web-push og valgfri kommunikasjon',
  'privacy.purpose.consent': 'Ditt valg eller samtykke, som du kan trekke tilbake',
  'privacy.purpose.noAds': 'Vi bruker ikke personopplysninger til tredjeparts målrettet annonsering og selger dem ikke til datameglere.',
  'privacy.visibility.heading': 'Synlighet og arrangøransvar',
  'privacy.visibility.p1':
    'Offentlige arrangementer, offentlige grupper, virksomhetsprofiler og informasjon du bevisst publiserer der, kan være synlig uten innlogging og deles utenfor Vennevent. Private arrangementer, grupper, planer, minner, lagrede personer og begrensede profilfelt styres av de aktuelle tilgangsreglene.',
  'privacy.visibility.p2':
    'Arrangører bestemmer hva de publiserer og må ha tillatelse til å laste opp arrangementsbeskrivelser, deltakeropplysninger og bilder. Vennevent gjør ikke krav på eierskap til arrangørinnhold. Du beholder rettighetene dine og gir Vennevent bare tillatelsen som trengs for å lagre, vise, distribuere og teknisk behandle innholdet for tjenesten.',
  'privacy.providers.heading': 'Tjenester som mottar begrensede opplysninger',
  'privacy.providers.intro': 'Vennevent bruker bare tjenesteleverandører der det trengs for å drive en funksjon:',
  'privacy.providers.infrastructure': 'lagrer kontoer, oppføringer og opplastede filer.',
  'privacy.providers.google': 'mottar opplysninger når du velger Google-innlogging.',
  'privacy.providers.mapbox': 'mottar søketekst eller koordinater når kartsøk, omvendt geokoding eller posisjonsfunksjoner brukes.',
  'privacy.providers.weather': 'mottar arrangementskoordinater og datoer når et nært værvarsel vises.',
  'privacy.providers.pixabay': 'mottar arrangørens bildesøk når det valgfrie bildesøket brukes.',
  'privacy.providers.sentry': ' mottar, når aktivert i produksjon, programfeil, ytelsesspor, IP-adresser og standard diagnostisk kontekst.',
  'privacy.providers.notificationsTitle': 'Leverandører av e-post og nettleser-push',
  'privacy.providers.notifications': 'mottar mottaker- og meldingsopplysningene som trengs for varsler du har aktivert.',
  'privacy.providers.twilio': 'mottar et telefonnummer når du ber om å verifisere det via SMS. Vennevent bruker ikke nummeret til innlogging eller varsler.',
  'privacy.providers.bookingTitle': 'eller en ekstern bestillingsleverandør',
  'privacy.providers.booking': 'mottar opplysninger når du starter en betaling eller følger en ekstern bestillingslenke.',
  'privacy.providers.transfer':
    'Leverandørene behandler data etter egne vilkår og kan behandle dem utenfor Norge eller EØS med en gyldig overføringsmekanisme. En ekstern lenke fører til en egen tjeneste med sin egen personvernpraksis.',
  'privacy.retention.heading': 'Lagringstid',
  'privacy.retention.chat': 'Arrangementschat slettes 48 timer etter at arrangementet avsluttes.',
  'privacy.retention.media': 'Arrangementsmedier slettes etter 7 dager, eller etter 14 dager hvis verten bruker engangsforlengelsen.',
  'privacy.retention.comments': 'Arrangementskommentarer slettes etter 30 dager.',
  'privacy.retention.events': 'Fullførte arrangementer slettes etter 3 kalendermåneder.',
  'privacy.retention.accounts': 'Inaktive kontoer slettes etter 1 år uten vellykket innlogging.',
  'privacy.retention.audit':
    'Revisjonsoppføringer for personvernhendelser inneholder en hashet brukeridentifikator og handlingskategori og slettes etter 30 dager.',
  'privacy.retention.contacts':
    'Ratelogg for kontaktmatching og SMS-verifiseringsforsøk slettes etter 24 timer. Importerte adressebokopplysninger beholdes ikke.',
  'privacy.retention.widgets':
    'Innebygde virksomhetsmoduler beholder bare daglige antall per virksomhet, flate og handling. De lagrer ikke besøksidentifikatorer eller rå henvisningsadresser. Antall slettes etter 90 dager, og små datamengder skjules i virksomhetsrapportering.',
  'privacy.retention.other':
    'Private minner du bevisst beholder, blir værende til du sletter minnet eller kontoen. Noen modererings-, transaksjons-, sikkerhets- eller juridiske oppføringer kan kreve en annen periode. Eksisterende sikkerhetskopier forsvinner etter planen for sikkerhetskopiering. En sletteforespørsel lager ikke en ny sikkerhetskopi.',
  'privacy.rights.heading': 'Dine valg og rettigheter',
  'privacy.rights.intro':
    'Avhengig av gjeldende lov kan du be om innsyn, retting, sletting, begrensning eller dataportabilitet, protestere og trekke samtykke når som helst.',
  'privacy.rights.settingsBefore': 'Endre profilsynlighet og varslingsvalg i',
  'privacy.rights.discovery': 'Deaktiver søk via e-post/telefon eller fjern et verifisert telefonnummer i Innstillinger → Personer.',
  'privacy.rights.export': 'Last ned en JSON-eksport fra kontrollsenteret for personvern.',
  'privacy.rights.sessions': 'Trekk tilbake alle innloggede økter og fjern enkelte push-abonnementer.',
  'privacy.rights.deletion': 'Planlegg kontosletting med en angrefrist på 7 dager.',
  'privacy.rights.complaint': 'Klag til Datatilsynet eller en annen kompetent tilsynsmyndighet.',
  'privacy.rights.account':
    'Å slette appen eller lukke nettleseren sletter ikke kontoen. Bruk slettekontrollen i Innstillinger. Innhold andre har laget om sin egen deltakelse, kan beholdes når de har et selvstendig lovlig grunnlag, men skal ikke lenger vise en slettet profil.',
  'privacy.storage.heading': 'Posisjon, informasjonskapsler og lokal lagring',
  'privacy.storage.location':
    'Nettleserposisjon forespørres først når du velger en posisjonsfunksjon. Introduksjonen lagrer avrundede koordinater som en utforskingsinnstilling. IP-oppslag kan anslå et grovt startområde slik at utforsking er nyttig uten GPS.',
  'privacy.storage.browser':
    'Vennevent bruker nettleserlagring til autentisering, innstillinger, hurtigbufrede resultater, nylige søk, frakoblet bruk og kortvarig værbufring. Nødvendig lagring kreves for at tjenesten skal fungere. Vennevent bruker ikke tredjeparts annonseinformasjonskapsler.',
  'privacy.children.heading': 'Barn og sensitive opplysninger',
  'privacy.children.body':
    'Vennevent er ikke ment for barn under minstealderen for å samtykke til en nettjeneste i landet sitt. Ikke publiser sensitive personopplysninger i offentlige arrangements-, gruppe-, innleggs- eller chatfelt. Alderskontroll lagres separat og vises ikke på offentlige profiler.',
  'privacy.security.heading': 'Sikkerhet og endringer',
  'privacy.security.body':
    'Vi bruker tilgangskontroller, signerte økter, autorisasjon på serveren, dataminimering og administrerte slettejobber. Ingen tjeneste kan garantere absolutt sikkerhet. Hvis et brudd medfører varslingsplikt, informeres berørte personer og myndigheter som påkrevd.',
  'privacy.security.changes':
    'Vi oppdaterer erklæringen når tjenesten eller leverandørene endres vesentlig. Ikrafttredelsesdatoen endres, og betydelige endringer kommuniseres i appen der det passer. Tidligere ordlyd bør beholdes i prosjekthistorikken.',
  'privacy.footer.help': 'Personvernkontroller er tilgjengelige uten å kontakte en administrator.',
  'privacy.footer.events': 'Tilbake til arrangementer',
  'privacy.footer.controls': 'Personvernkontroller',
} as const;
